export default __webpack_public_path__ + "static/media/element_spec_76.402e84e1.webp";